import { Link } from "react-router-dom";
import { ArrowUp, ShieldCheck } from "lucide-react";
import { LOGO_URL, COMPANY_NAME, P_IVA } from "@/constants/brand";

export const Footer = () => {
  const toTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.6 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer data-testid="main-footer" className="relative border-t border-brand/15 bg-obsidian px-5 sm:px-8 pt-16 pb-10">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div className="max-w-sm">
            <div className="flex items-center gap-3 mb-5">
              <img src={LOGO_URL} alt="Logo Io Amo La Mia Città" className="w-11 h-11 rounded-xl object-cover ring-1 ring-brand/40" />
              <span className="font-display font-extrabold tracking-tight text-white">
                IO AMO LA <span className="text-brand">MIA CITTÀ</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-muted2">
              La piattaforma di delivery locale dove le persone sono gestite da altre persone, non da un algoritmo.
            </p>
          </div>

          <div>
            <p className="font-display font-bold text-white text-sm tracking-widest uppercase mb-4">Dati Societari</p>
            <p data-testid="footer-company-data" className="text-sm text-muted2 leading-relaxed">
              {COMPANY_NAME}
              <br />
              P.IVA {P_IVA}
            </p>
          </div>

          <div>
            <p className="font-display font-bold text-white text-sm tracking-widest uppercase mb-4">Link Utili</p>
            <div className="flex flex-col gap-2.5">
              <Link to="/privacy-policy" data-testid="footer-privacy-link" className="text-sm text-muted2 hover:text-brand transition-colors duration-300">
                Privacy Policy
              </Link>
              <Link to="/cookie-policy" data-testid="footer-cookie-link" className="text-sm text-muted2 hover:text-brand transition-colors duration-300">
                Cookie Policy
              </Link>
              <Link to="/contatti" data-testid="footer-contatti-link" className="text-sm text-muted2 hover:text-brand transition-colors duration-300">
                Contatti
              </Link>
              <Link to="/admin" data-testid="footer-admin-link" className="text-sm text-muted2 hover:text-brand transition-colors duration-300">
                Area Riservata
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-brand/10 flex flex-col sm:flex-row items-center justify-between gap-5">
          <p className="text-xs text-dim flex items-center gap-2">
            <ShieldCheck className="w-3.5 h-3.5 text-brand" />
            © {new Date().getFullYear()} {COMPANY_NAME} — Tutti i diritti riservati
          </p>
          <button
            data-testid="footer-back-to-top"
            onClick={toTop}
            className="inline-flex items-center gap-2 text-xs font-bold text-muted2 hover:text-brand transition-colors duration-300"
            aria-label="Torna su"
          >
            TORNA SU <ArrowUp className="w-4 h-4" />
          </button>
        </div>
      </div>
    </footer>
  );
};
